// 服务器获取配置
const fingerprint = {
  namespaced: true,
  state: {
    fp: '',
  },
  getters: {
    fp: state => state.fp,
  },
  actions: {
    setFP: async ({ commit }) => {
      const { fp } = (window as any).INIT_DATA.configuration;
      commit('setFP', fp);
    },
  },
  mutations: {
    setFP(state, payload) {
      state.fp = payload;
    },
  },
};

export default fingerprint;
